package pwgs.ui.scenes.customentityeditorscene

import kotlinx.serialization.Serializable
import pwgs.ui.scenes.custompropertieseditorscene.ECustomFieldType
import visage.ds.forms.AFieldModel
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption
import visage.rmi.VisageController

@VisageController(CustomEntityEditorSceneProps::class, CustomEntityEditorSceneModel::class)
interface CustomEntityEditor {
    fun load()
    fun saveField()
}

@Serializable
data class CustomEntityEditorSceneProps(
    val projectId: Long,
    val entityKind: String,
    val entityId: String,
)

@Serializable
class CustomEntityEditorSceneModel(
    val fields: List<CustomEntityFieldModel>
) {
    var isLoading = true
    var editorDialogModel: CustomEntityFieldEditorDialogModel? = null
}

@Serializable
class CustomEntityFieldModel(
    val fieldName: String,
    val fieldType: ECustomFieldType,
    val fieldValue: String,
    val isEditable: Boolean,
    val isHidden: Boolean
)

@Serializable
class CustomEntityFieldEditorDialogModel(
    val fieldName: String,
    val fieldType: ECustomFieldType,
) {
    var isLoading = false
    var error: String? = null
    val boolFieldModel = MetaFieldModel("false", listOf(
        SelectOption("true", "True"),
        SelectOption("false", "False"),
    ))
    val otherFieldModel = FieldModel("")
}